import { render, staticRenderFns } from "./IdentitySelector.vue?vue&type=template&id=357f93f0&scoped=true"
import script from "./IdentitySelector.vue?vue&type=script&lang=js"
export * from "./IdentitySelector.vue?vue&type=script&lang=js"
import style0 from "./IdentitySelector.vue?vue&type=style&index=0&id=357f93f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f93f0",
  null
  
)

export default component.exports